import { useAccount } from '@src/contexts';
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Text from '@sendsprint/ui-react/dist/components/Text';
import Icon from '@sendsprint/ui-react/dist/components/Icon';
import ChevronDownOutline from '@sendsprint/ui-react/dist/icons/ChevronDownOutline';
import { Link } from 'react-router-dom';
import { Path } from '@src/navigations/routes';
import { ReactComponent as SendMoneyIcon } from '../../../assets/sendMoneyIcon.svg';
import { ReactComponent as ReceiveMoneyIcon } from '../../../assets/receiveMoneyIcon.svg';
import { useToggle } from '@src/hooks';
import PaymentLinkItems from '@src/pages/common/paymentLinks/components/paymentLinkItems';

const QuickAction = () => {
  const {
    handleTrue: handlePaymentLinkOpen,
    handleFalse: handlePaymentLinkClose,
    state: isPaymentLinkOpen
  } = useToggle();

  const { isRemittanceBusiness } = useAccount();
  if (!isRemittanceBusiness) return <></>;

  return (
    <div>
      <Menu>
        {({ open }) => (
          <div className="ss-relative ss-w-max">
            <Menu.Button className="ss-bg-primary1-800 ss-rounded-full focus:ss-focus-ring ss-flex ss-justify-center ss-text-white ss-py-[10px] ss-px-5 ss-items-center ss-shadow">
              <Text variant="paragraphSmall">Quick Action</Text>
              <Icon svg={ChevronDownOutline} size={18} />
            </Menu.Button>
            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95">
              <Menu.Items className="ss-absolute ss-overflow-hidden ss-z-10 ss-py-1 ss-px-1 ss-w-max ss-rounded ss-shadow ss-right-0 ss-top-[calc(100%+10px)] ss-bg-primary1-800 ss-text-white">
                <Menu.Item>
                  <Link
                    to={Path.SenderInitiateTransfer}
                    type="button"
                    className="focus:ss-focus-ring ss-flex ss-py-2 ss-px-6 hover:ss-bg-primary1-500 ss-w-full ss-items-center ss-gap-2">
                    <SendMoneyIcon className="ss-w-[16px] ss-h-[16px]" />
                    <Text variant="paragraphSmall" className="ss-relative ss-left-[5px]">
                      Send Money
                    </Text>
                  </Link>
                </Menu.Item>
                <Menu.Item>
                  <button
                    type="button"
                    onClick={handlePaymentLinkOpen}
                    className="focus:ss-focus-ring ss-flex ss-py-2 ss-px-6 hover:ss-bg-primary1-500 ss-w-full ss-items-center ss-gap-2">
                    <ReceiveMoneyIcon className="ss-w-[22px] ss-h-[22px]" />
                    <Text variant="paragraphSmall">Receive Money</Text>
                  </button>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </div>
        )}
      </Menu>
      <PaymentLinkItems
        handleClose={handlePaymentLinkClose}
        isOpen={isPaymentLinkOpen}
        variant="raas"
      />
    </div>
  );
};

export default QuickAction;
